import mirror from 'keymirror';
import { create, get, remove } from '../lib/streaks';
import { getModalType } from '../components/StreaksButton/StreaksButton';

export const actionTypes = mirror({
  STREAKS_GET_ERROR: null,
  STREAKS_GET_SUCCESS: null,
  STREAKS_CREATE_ERROR: null,
  STREAKS_CREATE_SUCCESS: null,
  STREAKS_IS_LOADING: null,
  STREAKS_HIDE_MODAL: null,
  STREAKS_SHOW_MODAL: null,
  STREAKS_SET_TEST_STATE: null,
  STREAKS_REMOVE_ERROR: null,
  STREAKS_REMOVE_SUCCESS: null,
  STREAKS_UPDATE_ANALYTICS: null,
  STREAKS_MODAL_QUEUE: null,
});

const streaksGetError = error => ({
  error,
  type: actionTypes.STREAKS_GET_ERROR,
});

const streaksGetSuccess = results => ({
  results,
  type: actionTypes.STREAKS_GET_SUCCESS,
});

const streaksCreateError = error => ({
  error,
  type: actionTypes.STREAKS_CREATE_ERROR,
});

const streaksCreateSuccess = data => ({
  results: data,
  type: actionTypes.STREAKS_CREATE_SUCCESS,
});

const streaksHideModal = () => ({
  type: actionTypes.STREAKS_HIDE_MODAL,
});

const streaksShowModal = modal => ({
  modal,
  type: actionTypes.STREAKS_SHOW_MODAL,
});

const streaksSetTestState = (data, duration) => ({
  results: data,
  duration,
  type: actionTypes.STREAKS_SET_TEST_STATE,
});

const streaksRemoveError = error => ({
  error,
  type: actionTypes.STREAKS_REMOVE_ERROR,
});

const streaksRemoveSuccess = results => ({
  results,
  type: actionTypes.STREAKS_REMOVE_SUCCESS,
});

const streaksIsLoading = () => ({
  type: actionTypes.STREAKS_IS_LOADING,
});

const streaksUpdateAnalytics = analytics => ({
  analytics,
  type: actionTypes.STREAKS_UPDATE_ANALYTICS,
});

const queueStreaksModal = queStreaksModal => ({
  queStreaksModal,
  type: actionTypes.STREAKS_MODAL_QUEUE,
});

export function createStreak(sessionId) {
  return async (dispatch, getState) => {
    const state = getState();
    const { results, shouldQueueStreaksModal, modal } = state.streaks;
    const { 'milestone-completed-today': milestoneCompletedToday } = results || {};
    if (!milestoneCompletedToday) {
      dispatch(streaksIsLoading());
      try {
        const data = await create(sessionId);
        dispatch(streaksCreateSuccess(data));
        if (!shouldQueueStreaksModal && !modal) {
          const { milestones } = data || {};
          const modalType = getModalType(milestones);
          dispatch(streaksShowModal(modalType));
        } else if (shouldQueueStreaksModal) {
          console.log('setting modal que');
          localStorage.setItem('streakModalInQueue', JSON.stringify(true));
        }
      } catch (error) {
        dispatch(streaksCreateError(error));
      }
    }
  };
}

export function getStreak() {
  return async (dispatch, getState) => {
    dispatch(streaksIsLoading());
    try {
      const state = getState();
      const { streaks } = state;
      const { results } = streaks || {};
      let data = null;
      if (!results) {
        data = await get();
      }
      if (results) {
        data = results;
      }
      dispatch(streaksGetSuccess(data));
    } catch (error) {
      dispatch(streaksGetError(error));
    }
  };
}

export function removeStreak() {
  return async dispatch => {
    dispatch(streaksIsLoading());
    try {
      await remove();
      /**
       * Calls get() to return user data
       * without milestones
       */
      const resp = await get();
      dispatch(streaksRemoveSuccess(resp));
    } catch (error) {
      const errorMessage = 'Error Removing Streak';
      dispatch(streaksRemoveError(errorMessage));
    }
  };
}

export function updateStreakLessons() {
  return async (dispatch, getState) => {
    const { streaks } = getState();
    const { analytics } = streaks;
    const incrementedValue = { lessonsCompleted: analytics.lessonsCompleted + 1 };
    const data = { ...analytics, ...incrementedValue };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function updateStreakVideos() {
  return async (dispatch, getState) => {
    const { streaks } = getState();
    const { analytics } = streaks;
    const incrementedValue = { videosWatched: analytics.videosWatched + 1 };
    const data = { ...analytics, ...incrementedValue };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function resetStreakAnalytics() {
  return async dispatch => {
    const data = {
      lessonsCompleted: 0,
      videosWatched: 0,
    };
    dispatch(streaksUpdateAnalytics(data));
  };
}

export function hideStreaksModal() {
  localStorage.setItem('streakModalInQueue', JSON.stringify(false));
  return async dispatch => {
    dispatch(streaksHideModal());
  };
}

export function showStreaksModal(data) {
  return async dispatch => {
    dispatch(streaksShowModal(data));
  };
}

export function shouldQueueStreaksModal(queueModal) {
  return async dispatch => {
    dispatch(queueStreaksModal(queueModal));
  };
}

export function checkStreaksModalQueue(preventModalDisplay) {
  return async (dispatch, getState) => {
    const state = getState();
    const { results } = state.streaks;
    const { milestones } = results || {};
    const streaksModalInQueue = JSON.parse(localStorage.getItem('streakModalInQueue'));
    if (!preventModalDisplay && streaksModalInQueue) {
      const modalType = getModalType(milestones);
      dispatch(queueStreaksModal(false));
      setTimeout(() => {
        dispatch(streaksShowModal(modalType));
      }, 1000);
    }
  };
}

/**
 * This action is only used for manipulating
 * streaks data for testing purposes. It has no
 * use inside of a production environment.
 */
export function setStreak(data, duration) {
  return async dispatch => {
    dispatch(streaksIsLoading());
    dispatch(streaksSetTestState(data, duration));
  };
}
